import api from "./api";

// Bitácora de movimientos de un registro (busquedaPersona) en el flujo de
// selección: una fila por cambio de estado, con la nota cuando se volvió atrás.
//
//   GET {API}/historial-proceso?userId=<id>&busPerId=<id>

export interface IHistorialProceso {
  estado: string;
  descripcionEstado: string;
  fecha: string;
  usuario: string | null;
  comentario: string;
}

export const getHistorialProceso = async (busPerId: string): Promise<IHistorialProceso[]> => {
  const response = await api.get(`historial-proceso`, {
    params: {
      userId: sessionStorage.getItem("usuarioId") as string,
      busPerId,
    },
  });
  return response.data?.data ?? [];
};
